/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementSettingEventEditResponse } from './EventManagementSettingEventEditResponse';

export type EventManagementSettingEventEditResponseApiRespoonse = {
    data?: EventManagementSettingEventEditResponse;
    status?: EventManagementSettingEventEditResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementSettingEventEditResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

